"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationBarIcon = void 0;
const react_1 = __importDefault(require("react"));
const _1 = require(".");
const IconWrapper_1 = __importDefault(require("../Icons/IconWrapper"));
const NotificationBarIcon = ({ type }) => {
    switch (type) {
        case _1.NotificationBarType.Info:
            return react_1.default.createElement(IconWrapper_1.default, { name: "Info", title: "Alert icon" });
        case _1.NotificationBarType.Alert:
            return react_1.default.createElement(IconWrapper_1.default, { name: "AlertCircle", title: "Alert icon" });
        case _1.NotificationBarType.Warning:
            return react_1.default.createElement(IconWrapper_1.default, { name: "AlertTriangle", title: "Warning icon" });
        case _1.NotificationBarType.Success:
            return react_1.default.createElement(IconWrapper_1.default, { name: "CheckCircle", title: "Success icon" });
        default:
            return null;
    }
};
exports.NotificationBarIcon = NotificationBarIcon;
exports.default = exports.NotificationBarIcon;
//# sourceMappingURL=NotificationBarIcon.js.map